export const PREVIOUS_ORDERS = Object.freeze({
  NORMAL: "normal",
  VOICE: "voice",
});
export const PREVIOUS_ORDERS_TYPES = new Map([
  [PREVIOUS_ORDERS.NORMAL, "طلبات عادية"],
  [PREVIOUS_ORDERS.VOICE, "طلبات صوتية"],
]);

export const ORDER_STATUS = {
  ACCEPTED: "accepted",
  FULFILLED: "fulfilled",
};
